// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3jrL6","colMaxWidth":"Table_colMaxWidth__2344Y"};